import styled from "styled-components";

export const TechnicalCardStyled = styled.div`
width: 32%;
height: 100%;
min-height: 21.625rem;
padding: 3.75rem;
background: #fff;
color: #000;
& span {
	height: 5px;
	width: 1.875rem;
	background-color: rgb(7, 66, 117);
	display: inline-block;
	margin: 1.25rem 0rem;
}
`